import { render, staticRenderFns } from "./InheritModules.vue?vue&type=template&id=4f1ad491&"
import script from "./InheritModules.vue?vue&type=script&lang=js&"
export * from "./InheritModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports